// extracted by mini-css-extract-plugin
export default {"container":"ReadyMadeSection-module__container__gDM7S util-module__legacy-max-width__znOAm","text":"ReadyMadeSection-module__text__ay3tc"};